import { Form, InputNumber, Typography } from "antd";
import React from "react";
import { yesNoOptions } from "../../../Options/commonOptions";
import {
  incontinenceOptions,
  stoolOptions,
} from "../../../Options/functionalAsessmentOptions";
import DeselectableRadioGroup from "../../../../../blocks/FormItems/DeselectableRadioGroup";
import { hexToRgba } from "../../../../../helpers/utility";
import {theme} from "antd";
const BowelNeeds = ({ form }) => {
  const { token } = theme.useToken();
  return (
    <>
      <Typography>Bowel Needs</Typography>
      <div
              className="subsection-card"
              style={{
                borderLeft: `2px solid ${hexToRgba(token.colorPrimaryHover, 0.2)}`,
                background: "transparent",
                marginTop: "8px",
                padding: "8px 12px",
                borderRadius: "8px",
              }}
            >
        <DeselectableRadioGroup
          label={"Indicates Urge to Pass Motion"}
          name={["bowel_needs", "indicates_need_to_pass_motion"]}
          options={yesNoOptions}
          form={form}
        />

        <DeselectableRadioGroup
          label={"Incontinence"}
          name={["bowel_needs", "incontinence"]}
          options={incontinenceOptions}
          form={form}
        />

        <DeselectableRadioGroup
          label={"Stools"}
          name={["bowel_needs", "stools"]}
          options={stoolOptions}
          form={form}
        />
        <Form.Item
          label="Days After Last Motion"
          name={["bowel_needs", "days_after_last_motion"]}
        >
          <InputNumber className="nurse-assessment-days-field" addonAfter="Days" />
        </Form.Item>

        <DeselectableRadioGroup
          label={"Colostomy"}
          name={["bowel_needs", "colostomy"]}
          options={yesNoOptions}
          form={form}
        />
      </div>
    </>
  );
};

export default BowelNeeds;
